export const debug = false;
export const local = false;

export const local_url = 'http://127.0.0.1:8000/api/';
export const staging_url = 'https://api-dev.capitalirrigation.com/api/';
export const production_url = 'https://api.capitalirrigation.com/api/';
export const old_cpm_address = '';
